import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import React from 'react';
import moment from 'moment';

export default function RequesterInfo({ info, t }) {
  return (
    <Grid>
      <Grid item xs={12} md={12} style={{ marginBottom: '10px' }}>
        <TextField
          value={info?.requesterFullName ?? ''}
          label={t('attachChildColumn_requesterFIO')}
        />
      </Grid>
      <Grid item xs={12} md={12} style={{ marginBottom: '10px' }}>
        <TextField
          value={info?.requesterIin ?? ''}
          label={t('attachChildColumn_requesterIIN')}
        />
      </Grid>{' '}
      <Grid item xs={12} md={12} style={{ marginBottom: '10px' }}>
        <TextField
          value={t(`attachChild_parentStatus_${info.parentStatus}`) ?? ''}
          label={t('attachChildColumn_parentStatus')}
        />
      </Grid>
      <Grid item xs={12} md={12} style={{ marginBottom: '10px' }}>
        <TextField value={info?.childIin ?? ''} label={t('attachChildColumn_childIin')} />
      </Grid>
      <Grid item xs={12} md={12} style={{ marginBottom: '10px' }}>
        <TextField
          value={t(`attachChildColumn_status_${info?.status}`) ?? ''}
          label={t('attachChildColumn_status')}
        />
      </Grid>
      <Grid item xs={12} md={12} style={{ marginBottom: '10px' }}>
        <TextField
          value={moment(info?.createdAt).format('DD.MM.YYYY HH:mm') ?? ''}
          label={t('attachChildColumn_date')}
        />
      </Grid>
    </Grid>
  );
}
